var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"auto"}},[(_vm.showIf)?_c('b-badge',{staticClass:"fitCont",attrs:{"pill":"","variant":"primary"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }